var ezdia;
(function (ezdia) {
    var NAME = 'entity';
    var TYPE = 'entity';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var pageParams;
    var dataTableSuffix = '-data-table';
    var actionTableSuffix = '-action-table';
    var $win = $(window);
    var DEFAULT = {
        baseTemplate: 'base-entity-link',
        formTemplate: 'base-entity-new-form',
        loadTemplate: 'base-entity-load',
        prefix: 'ez-entity-',
        cardPrefix: 'ez-entity-card-',
        changeCls: 'ez-entity-change-link'
    };
    var Entity = /** @class */ (function () {
        function Entity(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(Entity.prototype, "Defaults", {
            // eslint-disable-next-line class-methods-use-this
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        Entity.prototype.getCard = function (btn) {
            var options = this.options;
            var entity = options.column.entity;
            var id = this.entityID;
            var links = this.baseLink;
            var context = {
                hb_card_id: id,
                // eslint-disable-next-line no-unneeded-ternary
                hb_card_view: btn ? false : true,
                editAccess: entity.editAccess,
                widgetType: TYPE
            };
            var viewTable = this.entity.view === 'table';
            var content = '';
            var cardId = null;
            var template = null;
            $.ezdia.widgets.load(TYPE);
            if (viewTable) {
                template = $.ezdia.template.get('entity-table-view');
            }
            else {
                template = $.ezdia.template.get(entity.templateName, null, true);
            }
            if (btn) {
                var index = btn.data('index');
                var rows = this.getDataMap(false, index);
                context.hb_card_id += index;
                context.hb_frm_id = context.hb_card_id + "frm";
                context.rows = rows;
                cardId = $("#" + context.hb_card_id);
            }
            else {
                context.rows = this.getDataMap(true);
            }
            if (entity.type === 'rank') {
                context.rows = this.getRankData(context.rows);
            }
            content = template(context);
            if (btn) {
                if (viewTable) {
                    this.createFormDialog(context);
                    $.each(context.rows, function eachrows(key, obj) {
                        $.ezdia.widgets.init(obj, TYPE);
                    });
                }
                else {
                    content = $(content).html();
                    cardId.replaceWith(content);
                    cardId = $("#" + context.hb_card_id);
                }
                $.ezdia.widgets.create(TYPE);
            }
            else {
                $("#" + id).remove();
                links.after(content);
                if (viewTable && this.entity.editAccess) {
                    this.setRowHeight(context.hb_card_id);
                }
            }
            if (entity.type === 'rank') {
                $("#" + id).on('click', 'i[data-toggle]', this.toggleRankRows);
            }
        };
        Entity.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        Entity.prototype.init = function (options) {
            this.id = this.elem.id;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.name = this.options.column.name;
            this.entity = this.options.column.entity;
            this.entityID = this.options.cardPrefix + this.name;
            if (this.entity.config) {
                this.entity.config = $.ezdia.getJsonObject(this.entity.config);
                this.entity.view = this.entity.config.view;
            }
            else {
                this.entity.config = {};
            }
            this.render();
        };
        Entity.prototype.render = function () {
            var column = this.options.column;
            var value = column.editable
                ? $("[name=" + this.name + "]").val()
                : this.options.value;
            pageParams = $.ezdia.config.pageParams || {};
            this.base();
            if (value || column.config.disable_save) {
                getCardInfo.call(this, value);
            }
        };
        Entity.prototype.base = function () {
            var _a = this, _b = _a.options, baseTemplate = _b.baseTemplate, column = _b.column, _c = _a.entity, config = _c.config, createAccess = _c.createAccess;
            var editable = column.editable, id = column.id, name = column.name;
            var template = $.ezdia.template.get(baseTemplate);
            var context = $.ezdia.getJsonObject(config);
            context.id = baseTemplate + this.name;
            context.createAccess = createAccess;
            context.editable = column.config.disable_save ? false : editable;
            var content = template(context);
            if (editable) {
                this.hideElem = this.getToggleElem(column);
                this.hideElem.after(content);
            }
            else {
                $("#" + (id || name)).html(content);
            }
            this.baseAction();
            this.baseLink = $("#" + context.id);
        };
        Entity.prototype.baseAction = function () {
            var _this = this;
            var self = this;
            var options = this.options;
            var column = options.column;
            var entity = column.entity;
            var row = this.$elem.closest('[data-row="input"]');
            if (column.edittype) {
                row.find('[data-entity="change"]').on('click', function () {
                    _this.toggleChange();
                });
                row.find("[name=\"" + this.name + "\"]").on('change', function change() {
                    var value = this.value;
                    getCardInfo.call(self, value);
                });
            }
            if (column.edittype && entity.createAccess) {
                row.find('[data-entity="new"]').on('click', function () {
                    _this.createNewEntity();
                });
            }
            row
                .on('click', '[data-entity="edit"]', function click() {
                self.getCard($(this));
                self.toogleParentFormBtn();
            })
                .on('click', '[data-entity="cancel"]', function () {
                if (self.ajaxData) {
                    self.getCard();
                }
                else {
                    self.norecord();
                }
                self.toogleParentFormBtn(true);
            })
                .on('click', '[data-entity="save"]', function click() {
                var btn = $(this).button('loading');
                updateEntityData.call(self, btn);
                self.toogleParentFormBtn(true);
            })
                .on('click', '[data-entity="create"]', function click() {
                var btn = $(this).button('loading');
                createEntity.call(self, btn);
                self.toogleParentFormBtn(true);
            });
        };
        Entity.prototype.card = function (data) {
            if (data.rows && data.rows.length) {
                this.ajaxData = data.rows;
                this.getCard();
            }
            else {
                this.norecord();
            }
        };
        Entity.prototype.getDataMap = function (view, index) {
            var _this = this;
            var context = [];
            var data = this.ajaxData;
            var alerts = {};
            if (this.entity.config.view === 'custom') {
                $.each(data, function (i, obj) {
                    var content = _this.getCellData(obj);
                    if (alerts[content.url.value]) {
                        alerts[content.url.value].push(content);
                    }
                    else {
                        alerts[content.url.value] = [];
                        alerts[content.url.value].push(content);
                    }
                });
                return alerts;
            }
            if (view) {
                $.each(data, function (i, obj) {
                    var content = _this.getCellData(obj);
                    context.push(content);
                });
            }
            else {
                context = this.getCellData(data[index]);
            }
            return context;
        };
        Entity.prototype.getCellData = function (data) {
            var entity = this.options.column.entity;
            var contextObj = {};
            // eslint-disable-next-line consistent-return
            $.each(data.cell, function (i, mval) {
                var column = entity.fieldList[i];
                var name = '';
                var obj = {};
                if (!column) {
                    return true;
                }
                name = column.name;
                if ($.inArray(name, entity.showFields) !== -1) {
                    obj = {
                        column: column,
                        value: mval
                    };
                    contextObj[name] = obj;
                }
            });
            return contextObj;
        };
        Entity.prototype.getRankData = function (data) {
            var _this = this;
            var keywordsArray = [];
            var arr = [];
            data.sort(
            // eslint-disable-next-line no-return-assign
            function (a, b) { return (
            // eslint-disable-next-line no-sequences
            (a = a.rank_date.value),
                (b = b.rank_date.value),
                // eslint-disable-next-line no-nested-ternary
                a === b ? 0 : a > b ? -1 : 1); });
            $.each(data, function (i, obj) {
                var key = obj.keyword.value;
                var index = arr.indexOf(key);
                var mObj = {};
                if (index === -1) {
                    mObj = $.extend({}, { _hb_old_records: [], _hb_ranking_status: null }, obj);
                    arr.push(key);
                    keywordsArray.push(mObj);
                }
                else {
                    // eslint-disable-next-line no-underscore-dangle
                    keywordsArray[index]._hb_old_records.push(obj);
                    _this.getRankStatus(keywordsArray[index], obj);
                }
            });
            return keywordsArray.reverse();
        };
        Entity.prototype.getRankStatus = function (mObj, obj) {
            var mainStatus = mObj._hb_ranking_status;
            var oldrecords = mObj._hb_old_records;
            var index = null;
            var currObj = {};
            var currrank;
            var oldrank = null;
            var status = null;
            if (!mainStatus) {
                currObj = mObj;
                currrank = mObj.rank.value;
                oldrank = obj.rank.value;
            }
            else {
                index = oldrecords.length - 2;
                currObj = oldrecords[index];
                currrank = currObj.rank.value;
                oldrank = obj.rank.value;
            }
            currrank = +currrank;
            oldrank = +oldrank;
            if (currrank < oldrank) {
                status = 'up';
            }
            else if (currrank > oldrank) {
                status = 'down';
            }
            else {
                status = 'right';
            }
            currObj._hb_ranking_status = status;
        };
        Entity.prototype.createNewEntity = function () {
            var options = this.options;
            var entity = options.column.entity;
            var links = this.baseLink;
            var id = this.entityID;
            var template = $.ezdia.template.get(options.formTemplate);
            var content = '';
            var cardId = $("#" + id);
            $.ezdia.widgets.load(TYPE);
            if (!entity.createFieldList) {
                return;
            }
            $.each(entity.createFieldList, function (_i, column) {
                var obj = {
                    column: column
                };
                // eslint-disable-next-line no-param-reassign
                column.id = TYPE + "-form-" + column.name;
                var input = $.ezdia.inputs.getMarkup(obj, TYPE);
                content +=
                    column.edittype !== 'hidden' ? input.prop('outerHTML') : input;
                $.ezdia.widgets.init(obj, TYPE);
            });
            content = template({
                hb_card_id: id,
                hb_frm_id: id + "frm",
                content: content
            });
            cardId.remove();
            links.after(content);
            $.ezdia.widgets.create(TYPE);
        };
        Entity.prototype.toggleChange = function () {
            this.baseLink.removeClass(this.options.changeCls);
            if (this.hideElem) {
                this.hideElem.show();
            }
        };
        Entity.prototype.toggleRankRows = function (e) {
            var elem = $(e.currentTarget);
            var keyword = elem.data('toggle');
            var rows = elem.closest('table').find("tr[data-for=\"" + keyword + "\"]");
            var tr = elem.closest('tr');
            if (tr.hasClass('even')) {
                rows.addClass('even');
            }
            elem.toggleClass('fa-angle-down').toggleClass('fa-angle-up');
            tr.toggleClass('open');
            rows.toggle();
        };
        Entity.prototype.createFormDialog = function (context) {
            var self = this;
            var wrap = $.ezdia.getWrapper('ez-js-sys-entity-form-wrap');
            var template = $.ezdia.template.get('entity-popup-form');
            var content = template(context);
            wrap.html(content);
            this.openFormDialog = wrap.dialog({
                modal: true,
                title: 'Edit item',
                width: 620,
                height: 500,
                buttons: [
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            self.openFormDialog = null;
                            self.toogleParentFormBtn.call(self, true);
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Save',
                        class: 'btn-primary',
                        click: function () {
                            $.ezdia.loading.show();
                            updateEntityData.call(self, null, context.hb_frm_id);
                        }
                    }
                ]
            });
        };
        Entity.prototype.loading = function (load, error) {
            var options = this.options;
            var links = this.baseLink;
            var template;
            var loadId = "ez-entity-load-" + this.name;
            if (load) {
                template = $.ezdia.template.get(options.loadTemplate);
                links.hide();
                if (this.hideElem) {
                    this.hideElem.hide();
                }
                links.after(template({
                    id: loadId
                }));
            }
            else {
                $("#" + loadId).remove();
                if (error) {
                    links.show();
                    if (this.hideElem) {
                        this.hideElem.show();
                    }
                }
                else {
                    links.show().addClass(options.changeCls);
                }
            }
        };
        Entity.prototype.norecord = function (msg) {
            var links = this.baseLink;
            var id = this.entityID;
            var content = $('<div>', {
                id: id,
                class: 'alert alert-warning fade in',
                text: msg || 'No record found.'
            });
            $("#" + id).remove();
            this.toggleChange();
            links.after(content);
        };
        Entity.prototype.error = function (msg, isNoAction) {
            var links = this.baseLink;
            var id = this.entityID;
            var content = $('<div>', {
                id: id,
                class: 'alert alert-danger fade in',
                text: msg || 'Entity does not exists.'
            });
            $("#" + id).remove();
            this.toggleChange();
            if (!isNoAction) {
                links.after(content);
            }
        };
        Entity.prototype.toogleParentFormBtn = function (disabled) {
            if (!this.options.disableBtns) {
                return;
            }
            var btns = $("#" + this.options.disableBtns);
            if (disabled) {
                btns.css('display', '');
            }
            else {
                btns.css('display', 'none');
            }
        };
        Entity.prototype.getAccountName = function (rowID) {
            var grid = $('#grid');
            var row = {};
            var name = '';
            if (grid.length) {
                row = $('#grid').jqGrid('getRowData', rowID);
                name = row.account_name || row.tool_name;
                if ($(name).length) {
                    name = $(name).text();
                }
            }
            return name || pageParams.account;
        };
        Entity.prototype.getRoleName = function (rowID) {
            var grid = $('#grid');
            var row = {};
            var name = '';
            if (grid.length) {
                row = $('#grid').jqGrid('getRowData', rowID);
                name = row.role;
                if ($(name).length) {
                    name = $(name).text();
                }
            }
            return name || pageParams.role;
        };
        Entity.prototype.projectCardAll = function () {
            var id = this.entityID;
            var context = {
                hb_card_id: id
            };
            var template = $.ezdia.template.get('base-entity-project-all');
            $("#" + id).remove();
            this.baseLink.after(template(context));
        };
        Entity.prototype.getToggleElem = function (column) {
            var elem = this.$elem;
            if (column.name === 'account_name' || column.name === 'tool_name') {
                return elem.closest('.twitter-typeahead');
            }
            if (column.name === 'role') {
                return elem.closest('.twitter-typeahead');
            }
            switch (column.edittype) {
                case 'role':
                    if (column.config && column.config.url) {
                        elem = elem.closest('.twitter-typeahead');
                    }
                    break;
                case 'group':
                    elem = elem.closest('.twitter-typeahead');
                    break;
                default:
                    break;
            }
            return elem;
        };
        Entity.prototype.setRowHeight = function (cardId) {
            var _this = this;
            var self = this;
            var dataT = $("#" + cardId + dataTableSuffix);
            var dataTRows = dataT.find('tr');
            var actionT = $("#" + cardId + actionTableSuffix);
            var actionTRows = actionT.find('tr');
            actionTRows.each(function (i, row) {
                var height = $(dataTRows[i])
                    .find('td:first-child, th:first-child')
                    .outerHeight();
                $(row).find('.action').css({
                    height: height
                });
            });
            $win.on("resize." + TYPE, function () {
                if (!self.resize) {
                    self.resize = true;
                    setTimeout(function () {
                        _this.setRowHeight(cardId);
                        self.resize = false;
                    }, 500);
                }
            });
        };
        return Entity;
    }());
    // AJAX FUNCTIONS
    // =========================
    function getCardInfo(value, entityId) {
        var self = this;
        var dateRange = $.ezdia.config.pageParams.dateRange;
        var ruleId = $.ezdia.config.pageParams.ruleId;
        var options = this.options;
        var column = options.column;
        var entity = column.entity;
        var data = {};
        var gridRowID = ezdia.util.getSelectedGridItemsByGridId();
        this.loading(true);
        data.entityName = entity.name;
        if (value) {
            data.entityFieldVal = value;
        }
        if (entityId) {
            data.entityId = entityId;
        }
        if (entity.actionName && !entity.actionName.includes('accountName')) {
            data.accountName = this.getAccountName(gridRowID);
        }
        if (entity.actionName && !entity.actionName.includes('role')) {
            data.role = this.getRoleName(gridRowID);
        }
        if (dateRange) {
            data.dateRange = dateRange;
            if (dateRange === 'custom_date') {
                var _a = __read(ezdia.util.getUrlParams([
                    'fromDate',
                    'toDate',
                    'compareFromDate',
                    'compareToDate'
                ]), 4), fromDate = _a[0], toDate = _a[1], compareFromDate = _a[2], compareToDate = _a[3];
                data.fromDate = fromDate;
                data.toDate = toDate;
                data.compareFromDate = compareFromDate;
                data.compareToDate = compareToDate;
            }
        }
        if (ruleId) {
            data.ruleId = ruleId;
        }
        data.ids = gridRowID.join(',');
        if (entity.name === 'project_card' && value === 'All') {
            this.loading(false);
            this.projectCardAll();
            return;
        }
        if (entity.actionName) {
            $.ajax({
                type: 'POST',
                url: entity.actionName,
                data: data,
                dataType: 'json',
                success: function (response) {
                    self.loading(false);
                    self.card(response);
                },
                error: function (response) {
                    self.loading(false, true);
                    self.error(response);
                }
            });
        }
        else {
            if (column.editable) {
                self.loading(false, true);
                self.error("", true);
            }
            else {
                this.$elem.replaceWith(value);
            }
        }
    }
    function updateEntityData(btn, frmId) {
        var self = this;
        var dateRange = $.ezdia.config.pageParams.dateRange;
        var options = this.options;
        var entity = options.column.entity;
        var frm = frmId || btn.data('form');
        var entityFieldVal = $("[name=" + this.name + "]").val() || options.value;
        var gridRowID = ezdia.util.getSelectedGridItemsByGridId();
        var data = '';
        data += "entityName=" + entity.name;
        data += "&entityFieldVal=" + entityFieldVal;
        data += "&accountName=" + this.getAccountName(gridRowID);
        data += "&taskId=" + gridRowID;
        if (dateRange) {
            data += "&dateRange=" + dateRange;
        }
        var values = $("#" + frm).serialize();
        $.ajax({
            type: 'POST',
            url: "editEntityData.htm?" + values,
            data: data,
            dataType: 'json',
            success: function (response) {
                if (btn) {
                    btn.button('reset');
                }
                if (response.success) {
                    $.ezdia.showSuccessError({
                        message: response.msg
                    });
                    getCardInfo.call(self, entityFieldVal);
                }
                else {
                    self.error(response.msg);
                }
                if (self.openFormDialog) {
                    self.openFormDialog.dialog('close');
                }
                self.toogleParentFormBtn.call(self, true);
                $.ezdia.loading.hide();
            },
            error: function (response) {
                if (btn) {
                    btn.button('reset');
                }
                self.error(response);
                self.toogleParentFormBtn.call(self, true);
                $.ezdia.loading.hide();
            }
        });
    }
    function createEntity(btn) {
        var self = this;
        var dateRange = $.ezdia.config.pageParams.dateRange;
        var entity = this.options.column.entity;
        var frm = btn.data('form');
        var gridRowID = ezdia.util.getSelectedGridItemsByGridId();
        var data = '';
        data += "entityName=" + entity.name;
        var values = $("#" + frm).serialize();
        values += "&accountName=" + this.getAccountName(gridRowID);
        values += "&taskId=" + gridRowID;
        if (dateRange) {
            values += "&dateRange=" + dateRange;
        }
        $.ajax({
            type: 'POST',
            url: "createEntity.htm?" + values,
            data: data,
            dataType: 'json',
            success: function (response) {
                btn.button('reset');
                if (response.success && response.entityId) {
                    getCardInfo.call(self, '', response.entityId);
                }
                else {
                    self.error(response.msg);
                }
            },
            error: function (response) {
                btn.button('reset');
                self.error(response);
            }
        });
    }
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        getCard: Entity.prototype.getCard
        // refresh: Entity.prototype.refresh,
        // destroy: Entity.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _a = 1; _a < arguments.length; _a++) {
            args[_a - 1] = arguments[_a];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof Entity) {
            return inputObject;
        }
        return null;
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new Entity(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = Entity;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
